export default __webpack_public_path__ + "static/media/scarecrow.5744f074.jpg";